<script lang="ts" setup>
// import { computed } from 'vue'
// import { type RouteLocationRaw, RouterLink, type RouterLinkProps, useRouter } from 'vue-router'
import { RouterLink, type RouterLinkProps } from 'vue-router'

export type ARouterLinkProperties = RouterLinkProps

/**
 * RouterLink breaks page when trying to resolve a Route that is invalid
 * and throws hard to trace error,
 * This wrapper prevents the page from breaking
 * and instead produces an easier to trace `console.error`,
 * when an error occurs an empty span will be shown instead
 * this also allows to find out with the inspector what's going on
 *
 * To prevent the concole.error
 * and have a better fallback then an empty span
 * do something like
 * @example
 * `<AButton
 *    v-if="route.params.id"
 *    :to="{ name: RouteName.HOME, { id: route.params.id } }"
 * >
 *   X
 * </AButton>`
 * @example
 * `<AButton v-else disabled variant="ghost">-</AButton>`
 */

const properties = defineProps<ARouterLinkProperties>()

// function getIsValidToRoute(to: RouteLocationRaw): boolean {
//   if (!to) return true

//   try {
//     useRouter().resolve(to)
//     return true
//   } catch (error) {
//     console.error('[ARouterLink] Invalid route:', {
//       to: properties.to,
//       error,
//     })
//     return false
//   }
// }

// const isValidToRoute = computed((): boolean => {
//   return getIsValidToRoute(properties.to)
// })
</script>

<template>
  <!--  v-if="isValidToRoute" -->
  <RouterLink class="atabix-router-link" v-bind="{ ...properties, ...$attrs }">
    <template #default="slotProperties">
      <slot name="default" v-bind="slotProperties"></slot>
    </template>
  </RouterLink>

  <!-- <span v-else class="atabix-router-link atabix-router-link--invalid"></span> -->
</template>
